<agr-dialog (confirm)="save(true)" (alt)="saveAndNextSection()" (cancel)="cancel()" [data]="data">
  <div class="spacing--margin-horizontal spacing--margin-top fixed-header" #header>
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'observations-labels.period' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ getFirstDayOfWeek() | agrDate }} -<br />{{ getLastDayOfWeek() | agrDate }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left">
          <span class="text--small text--gray label">
            {{ 'observations-labels.start-section' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ sectionStartDate !== undefined ? (sectionStartDate | agrDate) : '' }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left">
          <span class="text--small text--gray label">
            {{ 'observations-labels.amountOfAnimalsStartSection' | translate }}
          </span>
          <span
            class="text--small text--bold label"
            data-test="week-registration__amountOfHensStartOfFlock"
          >
            {{ numberOfAnimalsStartOfSection | agrNumber }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left">
          <span class="text--small text--gray label">
            {{ 'observations-labels.amountOfAnimalsStartOfWeek' | translate }}
            {{ data.weekNr }}
          </span>
          <span
            class="text--small text--bold label"
            data-test="week-registration__amountOfHensStartOfWeek"
          >
            {{ numberOfAnimalsStartOfWeek | agrNumber }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left">
          <span class="text--small text--gray label">
            {{ 'observations-labels.breed' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ selectedSection.breed?.name }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left">
          <span class="text--small text--gray label">
            {{ 'observations-labels.gender' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ selectedSection.gender | translate }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left">
          <!-- section selector -->
          <mat-label class="text--small text--gray">
            {{ 'observations-labels.select-section' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            data-test="observations-registration__select-section"
            style="min-width: 150px"
            [(ngModel)]="selectedSectionId"
            (selectionChange)="sectionSelectChange($event)"
            [placeholder]="'observations-labels.select-section' | translate"
          >
            <mat-option *ngFor="let section of sections" [value]="section.id">
              {{ section.name + ' (' + section.barn.name + ')' }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>

  <div class="flex--row" *ngIf="!allSettingsAreOff; else allSettingsAreOffMessage">
    <!-- Show when daily or dynamic values are defined. -->
    <mat-tab-group
      [mat-stretch-tabs]="false"
      data-test="observations-registration__daytabs"
      animationDuration="0"
      color="accent"
      class="weekRegistrationTabs"
      [style.--top-height]="header.offsetHeight + 'px'"
    >
      <mat-tab
        *ngFor="let tab of tabs; let i = index"
        [label]="tab?.name"
        class="observations-registration-tab"
      >
        <app-observations-registration-form
          data-test="observations-registration__dailyView"
          *ngIf="formGroups[i] !== undefined"
          class="flex__child--auto"
          [formGroup]="formGroups[i]"
          [showFields]="tab.showFields"
          [chickAgeInDays]="tab.chickAgeInDays"
          (copyValuesCalledEvent)="copyValuesFromDay(i, $event)"
        >
        </app-observations-registration-form>
      </mat-tab>
    </mat-tab-group>
  </div>

  <ng-template #allSettingsAreOffMessage>
    <div class="notification notification-warning" data-test="all-settings-are-off">
      <mat-icon>warning</mat-icon>
      <b>{{ 'observations-labels.all-settings-are-off-title' | translate }}</b>
      <div>{{ 'observations-labels.all-settings-are-off-message' | translate }}</div>
    </div>
  </ng-template>
</agr-dialog>
